import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'admin/account/Offers';

export function useChargifyOffersQuery() {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () => userSession.webServiceHelper.callAsync<Api.IChargifyOffer[]>(`admin/account/Offers`, 'GET'),
		queryKey: [BASE_QUERY_KEY],
		refetchOnWindowFocus: false,
	});
}
